import { useRef, useEffect } from 'react';
import styles from './FilmStripFooter.module.css';

export default function FilmStripFooter({ width = 1440 }) {
  const railTopRef = useRef(null);
  const railBotRef = useRef(null);

  /* Generate sprocket holes to fill full width */
  useEffect(() => {
    const count = Math.ceil(width / 27) + 6;
    [railTopRef.current, railBotRef.current].forEach((rail) => {
      if (!rail) return;
      rail.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const hole = document.createElement('div');
        hole.className = styles.sprocketHole;
        rail.appendChild(hole);
      }
    });
  }, [width]);

  return (
    <div className={styles.root}>

      {/* ── Top sprocket rail ── */}
      <div className={styles.rail}>
        <div ref={railTopRef} className={styles.railInner} />
      </div>

      {/* ── Content row ── */}
      <div className={styles.content}>

        {/* Left: scene mark + identity */}
        <div className={styles.cellLeft}>
          <span className={styles.frameMark}>■ SCENE 06</span>
          <span className={styles.name}>Drew Hallé</span>
        </div>

        {/* Center: email + pulse dot */}
        <div className={styles.cellCenter}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span className={styles.emailPulse} />
            <a href="mailto:drew@drewhalle.com" className={styles.email}>
              drew@drewhalle.com
            </a>
          </div>
        </div>

        {/* Right: socials + copyright */}
        <div className={styles.cellRight}>
          <div className={styles.socials}>
            <a href="https://instagram.com/drewhalle" className={styles.social} target="_blank" rel="noopener noreferrer">IG</a>
            <a href="https://linkedin.com/in/drewhalle" className={styles.social} target="_blank" rel="noopener noreferrer">LI</a>
            <a href="https://vimeo.com/drewhalle" className={styles.social} target="_blank" rel="noopener noreferrer">VM</a>
          </div>
          <span className={styles.copy}>© MMXXVI · ALL FRAMES PROTECTED</span>
        </div>

      </div>

      {/* ── Bottom sprocket rail ── */}
      <div className={styles.rail}>
        <div ref={railBotRef} className={styles.railInner} />
      </div>

    </div>
  );
}
